import React from 'react';
import { updateSectionProps } from 'pxc-editor-web/src/actions';
import store from '@/store';
import {
  SymbolEntity,
  ShapeEntity,
  SectionEntity,
  isWebComponentEnvironment,
} from '@/helpers';
import { ZOOM } from '@/constants';
import svgElementDraggableListener from '../../hoc/svgElementDraggableListener';
import svgElementClickableListener from '../../hoc/svgElementClickableListener';
import svgRectResizable from '../../hoc/svgRectResizable';
import SectionContentComponent from './SectionContent';
import SectionArea from './SectionArea';

const webComponent = isWebComponentEnvironment();

class SectionRenderer extends React.PureComponent {
  state = {
    isSectionHovered: false,
  };

  handleDrop = e => {
    if (!webComponent) return;

    const { id } = this.props;
    const {
      core: { fictiveSections },
    } = store.getState();
    const selectedSection = Object.values(fictiveSections).find(item =>
      id.includes(item.id)
    );

    if (selectedSection) {
      if (!!SymbolEntity.symbol) {
        store.dispatch(
          updateSectionProps(selectedSection, SymbolEntity.symbol)
        );
        SymbolEntity.setSymbol(null);
      } else if (ShapeEntity.shape) {
        store.dispatch(
          updateSectionProps(selectedSection, { shape: ShapeEntity.shape })
        );
        ShapeEntity.resetShape();
      }
    }
  };

  onDragOver = e => {
    if (!webComponent) return;

    e.preventDefault();
  };

  handleMouseOver = () => {
    const { section, shield } = this.props;
    SectionEntity.setHover({ hover: true, section, shield });
    this.setState({ isSectionHovered: true });
  };

  handlMouseOut = () => {
    SectionEntity.setHover({ hover: false, section: null, shield: null });
    this.setState({ isSectionHovered: false });
  };

  render() {
    const { isSectionHovered } = this.state;
    const {
      id,
      className,
      svgStyleProps, // { strokeWidth?: number, stroke?: string }
      fillColor,
      resizeType,
      scaleCoef,
      rectProps,
      formatProps,
      section,
      shield,
      isSectionSelected,
      hideSection,
      hideContent,
      groupIdPostfix,
      // from svgElementClickableListener
      svgElementClickableRef,
      // from svgElementDraggableListener
      svgElementDraggableRef,
      dx: defaultDx = 0,
      dy: defaultDy = 0,
    } = this.props;
    const { hasBackground, shieldId } = formatProps;
    const dx = defaultDx / scaleCoef / ZOOM || 0;
    const dy = defaultDy / scaleCoef / ZOOM || 0;
    const isSectionContentAvailable = !hideContent;
    const isSectionAreaAvailable = !hideSection;
    const isSectionHoverAvailable = isSectionAreaAvailable;
    // TODO: move it to css
    const isActive =
      className &&
      (className.indexOf('clickable') >= 0 ||
        className.indexOf('draggable') >= 0);

    return (
      <g
        id={`${id}-group${groupIdPostfix}`}
        transform={`translate(${dx}, ${dy})`}
        style={isActive ? { cursor: 'pointer' } : null}
        className={className}
        ref={el => {
          svgElementDraggableRef(el);
          svgElementClickableRef(el);
        }}
        onDrop={this.handleDrop}
        onDragOver={this.onDragOver}
      >
        <defs>
          <clipPath id={`${id}-clip-path`}>
            <text id="measure-node">
              <tspan id={`${id}-measure`}></tspan>
            </text>
            <rect {...rectProps} />
          </clipPath>
        </defs>

        {isSectionAreaAvailable && (
          <SectionArea
            section={section}
            shield={shield}
            rectProps={rectProps}
            isSectionSelected={isSectionSelected}
            isSectionHovered={isSectionHovered}
          />
        )}

        <g clipPath={`url(#${shieldId}-clip-path)`}>
          <g clipPath={`url(#${id}-clip-path)`}>
            <rect {...rectProps} style={{ fill: 'transparent' }} />

            {hasBackground && fillColor && (
              <rect
                id={id}
                x={rectProps.x}
                y={rectProps.y}
                width={rectProps.width}
                height={rectProps.height}
                rx={0}
                style={{
                  ...svgStyleProps,
                  fill: (hasBackground && fillColor) || 'transparent',
                  stroke: 'transparent',
                }}
              />
            )}

            {isSectionContentAvailable && (
              <SectionContentComponent
                sectionId={id}
                rectProps={rectProps}
                formatProps={formatProps}
                resizeType={resizeType}
              />
            )}
          </g>
        </g>

        {isSectionHoverAvailable && (
          <foreignObject {...rectProps}>
            <div
              style={{ width: '100%', height: '100%' }}
              onMouseOver={this.handleMouseOver}
              onMouseOut={this.handlMouseOut}
              onTouchStart={this.handleMouseOver}
              onTouchEnd={this.handlMouseOut}
              onTouchCancel={this.handlMouseOut}
            />
          </foreignObject>
        )}
      </g>
    );
  }
}

// TODO: split section and resizable controls: wrong behavior when colored material and section has background and rotated.
// TODO: move assigning svgRectResizable and svgElementClickableListener outside this component
export default svgRectResizable(
  svgElementClickableListener(svgElementDraggableListener(SectionRenderer))
);
